import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Sessions ride on the backend's httpOnly `session_token` cookie, so no token is
// ever stored in JS-readable storage where XSS could reach it.
export const api = axios.create({ baseURL: API, withCredentials: true });
